import React from "react";

const Card = ({ data, css }) => {
  return (
    <article className={`${css.card} w-full`}>
      <img src={data.img} alt="IT Ghar" />
      <h5 className="bg-[#EFF3FF] w-full py-[25px] mb-10 max-sm:mb-0 px-[23px] text-[#000000] text-xl font-bold font-fira">
        {data.title}
      </h5>
    </article>
  );
};

export default Card;
